<template>
  <div class="sales-chart__chart-wrapper sales-chart__chart-wrapper--loading">
    <div><MoonLoader size="75px" color="#444444"></MoonLoader></div>
    <div class="loadingText">Loading...</div>
  </div>
</template>

<script>
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min';

  export default {
    name: 'ChartLoader',
    components: {
      MoonLoader,
    },
  };
</script>
